import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const SingleInquiryIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M13 16.6666H10.0001H3.33341C2.41675 16.6666 1.66675 15.9166 1.66675 15V4.99998C1.66675 4.08331 2.41675 3.33331 3.33341 3.33331H16.6667C17.5834 3.33331 18.3334 4.08331 18.3334 4.99998V8"
                stroke="currentColor"
                fill="none"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.3334 5L10.0001 10.8333L1.66675 5"
                stroke="currentColor"
                fill="none"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.1501 16.9C16.5644 16.9 16.9001 16.5642 16.9001 16.15C16.9001 15.7358 16.5644 15.4 16.1501 15.4C15.7359 15.4 15.4001 15.7358 15.4001 16.15C15.4001 16.5642 15.7359 16.9 16.1501 16.9Z"
                fill="currentColor"
            />
            <path
                d="M16.2075 14.2C16.2075 13.6609 16.5406 13.617 17.0319 13.4317C17.6481 13.1959 18.0313 12.5893 17.998 11.9153C17.948 11.1571 17.3484 10.5505 16.5989 10.5C15.5811 10.4999 15 11.2331 15 12.0079"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </SvgIcon>
    );
};
